// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"support-pre-footer_textWrapper__ac3qN","ctaContainer":"support-pre-footer_ctaContainer__2TqH9","ctaButton":"support-pre-footer_ctaButton__LlgKB"};